import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { aliases, md } from 'vuetify/iconsets/md';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { fr, en } from 'vuetify/locale';

const availableLocales = { fr, en };

const myCustomTheme = {
	dark: false,
	colors: {
		primary: '#1c79bb',
		'primary-darken-1': '#155e93',
		secondary: '#FF9800',
		'secondary-darken-1': '#e68900',
		tertiary: '#4CAF50',
		background: '#FFFFFF',
		surface: '#fcfcfc',
		'surface-variant': '#f0f4f9',
		'on-surface-variant': '#1d1b20',
		error: '#E7003E',
		info: '#2196F3',
		success: '#4CAF50',
		warning: '#ff5722',
		'on-primary': '#ffffff',
		'on-secondary': '#ffffff',
		'on-tertiary': '#ffffff',
		'on-background': '#1d1b20',
		'on-surface': '#1d1b20',
		'on-error': '#ffffff',
		'on-info': '#ffffff',
		'on-success': '#ffffff',
		'on-warning': '#ffffff',
		// 1f1f1f
		// 444746
	},
};

export function createMyVuetify(userLocale = 'fr') {
	return createVuetify({
		components,
		directives,

		icons: {
			defaultSet: 'md',
			aliases,
			sets: {
				md,
			},
		},

		locale: {
			locale: userLocale,
			fallback: 'fr',
			messages: availableLocales,
		},

		theme: {
			defaultTheme: 'myCustomTheme',
			themes: {
				myCustomTheme,
			},
		},
	});
}
